import {TextField} from "@mui/material";
import type {FormField} from "hooks/useForm";
import type {FC} from "react";

type EmailInputProps = FormField<string> & {
  disabled?: boolean;
  size?: "small" | "medium";
  required?: boolean;
};

const EmailInput: FC<EmailInputProps> = props => {
  const {value, error, onChange, onBlur, disabled, size, required} = props;

  return (
    <TextField
      label="Email"
      placeholder="e.g., example@email.com"
      value={value}
      onChange={e => onChange(e.target.value)}
      onBlur={onBlur}
      error={!!error}
      helperText={error}
      fullWidth
      margin="normal"
      slotProps={{formHelperText: {sx: {marginLeft: 0}}}}
      disabled={disabled}
      size={size}
      required={required}
    />
  );
};

export default EmailInput;
